import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ServiceQuality = () => {
  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12 max-w-4xl mx-auto">
          <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-8">
            Calidad de Servicios
          </h1>
          
          <div className="prose dark:prose-invert max-w-none">
            <p className="text-gray-600 dark:text-gray-300 mb-2">
              Documento Informativo General
            </p>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Última actualización: 7 de diciembre de 2025
            </p>
            
            <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 p-6 mb-8">
              <p className="text-gray-700 dark:text-gray-300">
                <strong>Calidad de Servicio</strong> es un marco avanzado de aseguramiento operativo incorporado en la plataforma GPT-JDP para mejorar la calidad, consistencia y estabilidad del ecosistema en todas sus funciones. Este protocolo establece lineamientos de verificación interna, monitoreo continuo y control de integridad en los procesos esenciales del sistema.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mt-4">
                Su propósito es brindar una experiencia más confiable y eficiente a todos los usuarios, especialmente en operaciones relacionadas con suscripciones, automatizaciones, agentes, módulos inteligentes y cualquier herramienta asociada a la plataforma.
              </p>
            </div>
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. Propósito General del Protocolo</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Se implementa para:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Optimizar el funcionamiento interno de los servicios.</li>
                <li>Aumentar la precisión y consistencia en la ejecución de procesos.</li>
                <li>Monitorear el rendimiento para evitar interrupciones inesperadas.</li>
                <li>Validar automáticamente que las funciones del sistema trabajen según los estándares definidos.</li>
                <li>Mejorar la trazabilidad de ciertos eventos operativos del ecosistema.</li>
                <li>Asegurar una coordinación fluida entre los módulos de la plataforma.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Estas mejoras permiten ofrecer un entorno más estable, transparente y predecible.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. Alcance</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Se aplica de forma transversal a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Gestión de cuentas y suscripciones</li>
                <li>Herramientas internas del ecosistema</li>
                <li>Flujo de datos operativo</li>
                <li>Interacciones entre módulos automatizados</li>
                <li>Procesos de validación para actualizaciones y cambios del sistema</li>
                <li>Control de calidad de funciones avanzadas</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                No modifica Términos de Uso, Políticas de Privacidad ni condiciones comerciales, sino que actúa como un marco de soporte que optimiza su cumplimiento.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. Componentes Generales</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Incluye los siguientes ámbitos:
              </p>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">3.1. Verificación Interna Dinámica</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Revisión periódica automatizada para asegurar el correcto funcionamiento de los módulos y herramientas.
              </p>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">3.2. Integridad Operativa</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Supervisión constante de los flujos internos para evitar inconsistencias y mantener niveles elevados de confiabilidad.
              </p>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">3.3. Monitoreo de Rendimiento</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Evaluación continua de tiempos de respuesta, uso de recursos y estabilidad de las funciones.
              </p>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">3.4. Control de Actualizaciones</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Validación de cambios y mejoras antes, durante y después de su implementación para evitar errores de ejecución.
              </p>

              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 mt-4">3.5. Trazabilidad Técnica Ampliada</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Registro estructural de eventos importantes que permiten mejorar la precisión del sistema a largo plazo.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Beneficios para el Usuario</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Ofrece:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Mayor estabilidad general del ecosistema</li>
                <li>Mejor calidad en la ejecución de procesos</li>
                <li>Reducción de errores operativos</li>
                <li>Experiencias más consistentes</li>
                <li>Actualizaciones más seguras y fluidas</li>
                <li>Mayor precisión en funciones avanzadas</li>
                <li>Mejor continuidad en proyectos de automatización y agentes inteligentes</li>
                <li>Flujos más predecibles y optimizados</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Actualizaciones del Protocolo</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Puede ser actualizado para incorporar nuevas mejoras técnicas, funcionales o estructurales.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Cualquier cambio será reflejado en esta página, sin afectar retroactivamente a los usuarios.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">6. Disponibilidad del Documento</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Este documento acompaña a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Términos de Uso</li>
                <li>Política de Privacidad</li>
                <li>Política de Reembolsos</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Su función es exclusivamente informativa y describe el marco general de calidad operativa aplicado en la plataforma GPT-JDP.
              </p>
            </section>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default ServiceQuality;
